import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { TealiumTrackLinkOnsiteDirective } from '@mobi/tea-tagmanager-ng-jslib';

import { NavigationItem } from '../../model/atomic-model';

@Component({
    selector: 'oiv-viewer-navigation-index',
    templateUrl: './navigation-index.component.html',
    styleUrls: ['./navigation-index.component.scss'],
    imports: [MobiUiIconComponent, TealiumTrackLinkOnsiteDirective],
    providers: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationIndexComponent {
    @Input() navigationItems: NavigationItem[] = [];

    @Output() navigationClick = new EventEmitter<NavigationItem>();
}
